// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

// Environment
import { environment } from '@env/environment';

// angulartics
import { Angulartics2Module } from 'angulartics2';

// Angular Material
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';

// QR Codes
import { QRCodeModule } from 'angularx-qrcode';

// App Components
import { AppComponent } from '@app/app.component';
import { WelcomeComponent } from '@app/containers/welcome/welcome.component';
import { DetailsComponent } from '@app/containers/details/details.component';
import { ContentHeaderComponent } from '@app/components/content-header/content-header.component';
import { GuestSignInComponent } from '@app/containers/guest-sign-in/guest-sign-in.component';
import { SurveyComponent } from '@app/containers/survey/survey.component';
import { DrawerComponent } from '@app/components/drawer/drawer.component';
import { SurveyThanksComponent } from './containers/survey-thanks/survey-thanks.component';
import { AgentComponent } from './components/agent/agent.component';
import { AdminSettingsComponent } from './containers/admin-settings/admin-settings.component';
import { OpenHouseSelectComponent } from './containers/open-house-select/open-house-select.component';
import { AdminFeedbackComponent } from './containers/admin-feedback/admin-feedback.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { GuestIdleComponent } from './components/guest-idle/guest-idle.component';
import { SurveyStepperComponent } from './components/survey-stepper/survey-stepper.component';
import { CloseOpenHouseDialogComponent } from './components/close-open-house-dialog/close-open-house-dialog.component';
import { LoginComponent } from './containers/login/login.component';
import { ImagePreloaderComponent } from './components/image-preloader/image-preloader.component';
import { ConfirmLogoutComponent } from './components/confirm-logout/confirm-logout.component';
import { GoToAdminDashboardComponent } from './components/go-to-admin-dashboard/go-to-admin-dashboard.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { AdminDashboardComponent } from './containers/admin-dashboard/admin-dashboard.component';
import { AdminGuestSelectComponent } from './containers/admin-guest-select/admin-guest-select.component';
import { AdminGuestDetailsComponent } from './containers/admin-guest-details/admin-guest-details.component';
import { ReturnToSurveyDialogComponent } from './components/return-to-survey-dialog/return-to-survey-dialog.component';
import { ImportGuestDialogComponent } from './components/import-guest-dialog/import-guest-dialog.component';
import { PhoneMaskDirective } from './components/phone-mask/phone-mask.directive';

// routes
const routes: Routes = [
  { path: 'welcome', component: WelcomeComponent, data: { state: 'welcome' } },
  { path: 'sign-in', component: GuestSignInComponent, data: { state: 'sign-in' } },
  { path: 'survey', component: SurveyComponent, data: { state: 'survey' } },
  { path: 'login', component: LoginComponent, data: { state: 'login' } },
  { path: 'open-house-select', component: OpenHouseSelectComponent, data: { state: 'open-house-select' } },
  { path: 'admin-dashboard', component: AdminDashboardComponent, data: { state: 'admin-dashboard' } },
  { path: 'admin-guest-select', component: AdminGuestSelectComponent, data: { state: 'admin-guest-select' } },
  { path: 'admin-guest-details', component: AdminGuestDetailsComponent, data: { state: 'admin-guest-details' } },
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    AppComponent,
    DetailsComponent,
    ContentHeaderComponent,
    WelcomeComponent,
    GuestSignInComponent,
    SurveyComponent,
    DrawerComponent,
    SurveyThanksComponent,
    AgentComponent,
    AdminSettingsComponent,
    OpenHouseSelectComponent,
    AdminFeedbackComponent,
    BackButtonComponent,
    GuestIdleComponent,
    SurveyStepperComponent,
    CloseOpenHouseDialogComponent,
    LoginComponent,
    ImagePreloaderComponent,
    ConfirmLogoutComponent,
    GoToAdminDashboardComponent,
    SearchBarComponent,
    AdminDashboardComponent,
    AdminGuestSelectComponent,
    AdminGuestDetailsComponent,
    ReturnToSurveyDialogComponent,
    ImportGuestDialogComponent,
    PhoneMaskDirective
  ],
  entryComponents: [
    AdminSettingsComponent,
    OpenHouseSelectComponent,
    AdminFeedbackComponent,
    SurveyThanksComponent,
    GuestIdleComponent,
    CloseOpenHouseDialogComponent,
    ConfirmLogoutComponent,
    GoToAdminDashboardComponent,
    SearchBarComponent,
    ReturnToSurveyDialogComponent,
    ImportGuestDialogComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    MatIconModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatTabsModule,
    QRCodeModule,
    Angulartics2Module.forRoot(),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
